import { NgModule } from "@angular/core";
import { FooterComponent } from "../components/footer/footer.component";
import { HeaderComponent } from "../components/header/header.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { LoadingIndicatorComponent } from "../components/loading-indicator/loading-indicator.component";
import { BackButtonComponent } from "../components/buttons/back-button/back-button.component";
import { ProgressBarComponent } from "../components/progress-bar/progress-bar.component";
import { InLineAlertComponent } from "../components/in-line-alert/in-line-alert.component";
import { QuestionInputCurrencyComponent } from "../components/inputs/question-input-currency/question-input-currency.component";
import { TooltipComponent } from "../components/tooltip/tooltip.component";
import { OneCurrencyPipe } from "../pipes/one-currency.pipe";
import { OneCurrencyEuroPipe } from "../pipes/one-currency-euro.pipe";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { FeedbackCardComponent } from "../components/feedback-card/feedback-card.component";
import { QuestionDropdownComponent } from "../components/inputs/question-dropdown/question-dropdown.component";
import { QuestionInputComponent } from "../components/inputs/question-input/question-input.component";
import { QuestionDateComponent } from "../components/inputs/question-date/question-date.component";
import { QuestionDateExpiryComponent } from "../components/inputs/question-date-expiry/question-date-expiry.component";
import { QuestionButtonCheckboxComponent } from "../components/inputs/question-button-checkbox/question-button-checkbox.component";
import { QuestionButtonComponent } from "../components/inputs/question-button/question-button.component";
import { QuestionDatepickerComponent } from "../components/inputs/question-date-picker/question-date-picker.component";
import { HtmlSanitizePipe } from "../pipes/html-sanitize.pipe";
import { AngularMaterialModule } from "../material.module";
import { ToastNotificationComponent } from "../components/toast-notification/toast-notification.component";
import { BaseModalComponent } from "../components/modal/base-modal/base-modal.component";
import { ModalIconsComponent } from "../components/modal/modal-icons/modal-icons.component";
import { AccordionItemComponent } from "../components/accordion-item/accordion-item.component";
import { CalcNavButtonsComponent } from "../components/buttons/calc-nav-buttons/calc-nav-buttons.component";
import { DropdownDirective } from "../directives/dropdown-directive/dropdown.directive";
import { UnloadBrowserNotificationDirective } from "../directives/unload-browser-notification.directive";
import { DobFormatDirective } from "../directives/dob-format.directive";

@NgModule({
    exports: [
        HttpClientModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FooterComponent,
        HeaderComponent,
        LoadingIndicatorComponent,
        BackButtonComponent,
        ProgressBarComponent,
        AccordionItemComponent,
        InLineAlertComponent,
        TooltipComponent,
        FeedbackCardComponent,
        OneCurrencyPipe,
        OneCurrencyEuroPipe,
        QuestionInputCurrencyComponent,
        QuestionDropdownComponent,
        QuestionInputComponent,
        QuestionDateComponent,
        QuestionDateExpiryComponent,
        QuestionButtonCheckboxComponent,
        QuestionButtonComponent,
        QuestionDatepickerComponent,
        HtmlSanitizePipe,
        BaseModalComponent,
        ToastNotificationComponent,
        ModalIconsComponent,
        CalcNavButtonsComponent,
        DropdownDirective,
        UnloadBrowserNotificationDirective,
        DobFormatDirective
    ], imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        CurrencyMaskModule,
        AngularMaterialModule,
        NgOptimizedImage,
        FooterComponent,
        HeaderComponent,
        LoadingIndicatorComponent,
        BackButtonComponent,
        ProgressBarComponent,
        AccordionItemComponent,
        InLineAlertComponent,
        TooltipComponent,
        FeedbackCardComponent,
        OneCurrencyPipe,
        OneCurrencyEuroPipe,
        QuestionInputCurrencyComponent,
        QuestionDropdownComponent,
        QuestionInputComponent,
        QuestionDateComponent,
        QuestionDateExpiryComponent,
        QuestionButtonCheckboxComponent,
        QuestionButtonComponent,
        QuestionDatepickerComponent,
        HtmlSanitizePipe,
        ToastNotificationComponent,
        BaseModalComponent,
        ModalIconsComponent,
        CalcNavButtonsComponent,
        DropdownDirective,
        UnloadBrowserNotificationDirective,
        DobFormatDirective
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class SharedModule { }
